import { get, set } from 'lodash/fp';
import { OperationVariables, QueryHookOptions, useQuery } from '@apollo/client';

import { Article } from '../../../../types/__codegen__/sanity/graphql';
import { GET_BLOG_POST, GET_LATEST_BLOG_POSTS } from '../../../../cms/queries';
import uniqueContentWithDraftPrecedence from '../../../../cms/utils/unique-content-with-draft-precedence';

type ArticleQueryResult = {
  data: Article[] | null;
  isLoading: boolean;
  error: Error | undefined;
};

type UseGetArticleParams = {
  slug?: string;
  options: QueryHookOptions<any, OperationVariables>;
};

const useGetArticle = ({ options, slug }: UseGetArticleParams): ArticleQueryResult => {
  const updatedOptions = slug ? set('variables.identifier', slug, options) : options;
  const queryToFetch = slug ? GET_BLOG_POST : GET_LATEST_BLOG_POSTS;
  const { data, loading: isLoading, error } = useQuery(queryToFetch, updatedOptions);
  const articles = uniqueContentWithDraftPrecedence<Article>(get('allArticle', data));
  return { data: articles, error, isLoading };
};

export default useGetArticle;
